import { FC, useEffect } from 'react';

import { css, Global } from '@emotion/react';
import { ToucanColors, ToucanComponents } from '@jointoucan/toucan-design';
import { Box } from '@mui/material';

import Layout from '~/components/shared/Layout';
import { trackEvent } from '~/helpers/analytics';
import { useExtensionConfig } from '~/hooks/useExtensionConfig';
import { BrowserName } from '~/lib/extension-config';

import { BrowserInfo } from './BrowserInfo';
import { DictionaryInfo } from './DictionaryInfo';
import { DoctorContext } from './DoctorContext';
import { Download } from './Download';
import { ExtensionInfo } from './ExtensionInfo';
import { PermissionInfo } from './PermissionInfo';
import { SafariAlert } from './SafariAlert';
import { UserInfo } from './UserInfo';

const { Typography } = ToucanComponents;

export const Doctor: FC = () => {
  const { browserName } = useExtensionConfig();

  useEffect(() => {
    trackEvent({ name: 'Doctor page view' });
  }, []);

  return (
    <DoctorContext>
      <Global
        styles={css`
          body {
            background: url(/images/home/md-backgroundHomeSubscription.svg);
            background-size: cover;
            background-attachment: fixed;
            background-color: ${ToucanColors.blue[100]};
          }
        `}
      />
      <Box p={5}>
        <Layout isNavbarVisible={false} hasFooter={false}>
          <Box display="flex" alignItems="center">
            <Box pr={2}>
              <img src="/images/toucan-doctor.svg" alt="Toucan" width="64px" height="64px" />
            </Box>
            <Typography variant="lg" font="secondary">
              Toucan Doctor
            </Typography>
            <Box flex="1" />
            <Download />
          </Box>
          {browserName === BrowserName.Safari && <SafariAlert px={3} pt={3} />}
          <Box display="flex" flexWrap="wrap" pt={3}>
            <Box pb={3} pr={3}>
              <UserInfo />
            </Box>
            <Box pb={3} pr={3}>
              <ExtensionInfo />
            </Box>
            <Box pb={3} pr={3}>
              <DictionaryInfo />
            </Box>
            <Box pb={3} pr={3}>
              <BrowserInfo />
            </Box>
            <Box pb={3} pr={3}>
              <PermissionInfo />
            </Box>
          </Box>
        </Layout>
      </Box>
    </DoctorContext>
  );
};
